/**
 * IMPORTS
 */

import type { IExcluirUsuarioClienteResponseApi } from "@/data/dtos/response-api/usuarios-cliente/excluir-usuario-cliente-response-api";
//
import { AppError } from "@/domain/errors/app-error";
// typings
import type { IExcluirUsuarioClienteRepository } from "@/domain/repositories/usuarios-cliente/excluir-usuario-cliente-repository-contract";

/**
 * Caso de uso — excluir permanentemente o vínculo usuário do cliente.
 */
export class ExcluirUsuarioClienteUseCase {
  private readonly repository: IExcluirUsuarioClienteRepository;

  constructor(repository: IExcluirUsuarioClienteRepository) {
    this.repository = repository;
  }

  async execute(userId: number): Promise<IExcluirUsuarioClienteResponseApi> {
    if (!userId || userId <= 0 || !Number.isFinite(userId)) {
      throw new AppError("Identificador do usuário inválido!");
    }

    return this.repository.delete(userId);
  }
}
